import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';

import { type TourEvent, Z_CALENDAR_EVENT_TYPE, type ZCalendarEvent } from '../constants';

// Shared classification and timing helpers for tour events, used by both the day layout algorithm
// (z-order + cancelled cascade) and the per-slot tile cap so a single definition of "cancelled tour"
// and "overlap" drives both.

export type Interval = { start: number; end: number };

export const isTourEvent = (event: ZCalendarEvent): event is TourEvent =>
  event.eventType === Z_CALENDAR_EVENT_TYPE.TOUR;

export const isCancelledTourEvent = (event: ZCalendarEvent): boolean =>
  isTourEvent(event) && event.tourStatus === TourStatusForZcheduler.CANCELLED;

// Half-open overlap: two time ranges share at least one instant (touching endpoints do not count).
export const intervalsOverlap = (a: Interval, b: Interval): boolean => a.start < b.end && b.start < a.end;
